import "./ProperOnboarding.css";
import ContentPage from "./ContentPage";
import { ReactComponent as FeedbackAnalysisGraph } from "./static/images/FeedbackAnalysisGraph.svg";
import { ReactComponent as RightArrow } from "./static/icons/RightArrow.svg";
import Carousel1 from "./static/big-images/UproadOnboarding1.png";
import Carousel2 from "./static/big-images/UproadOnboarding2.png";
import Carousel3 from "./static/big-images/UproadOnboarding3.png";
import Carousel4 from "./static/big-images/UproadOnboarding4.png";

import Button from "./Button";
import { goToPage } from "./Slide";
import Highlighter from "./Highlighter";
import Carousel from "./Carousel";
import AnimatedDiv from "./AnimatedDiv";

function ProperOnboarding() {
  return (
    <ContentPage>
      <AnimatedDiv>
        <h2>Onboarding that solves user problems</h2>

        <h3>Role</h3>
        <p>UX Researcher | UX Writer | Product Designer </p>

        <h3>First things first. Meet Uproad.</h3>
        <p>
          Uproad app is a simple mobile tolling solution. With Uproad drivers
          can use toll roads, skip cash lanes and conveniently pay toll charges
          on the go. On top of that, users can receive real-time Toll Alerts
          with estimated toll costs every time they pass a toll point.{" "}
        </p>
      </AnimatedDiv>

      <AnimatedDiv>
        <h3>Challenges</h3>
        <p>
          Tolling apps tend to struggle with{" "}
          <a
            href="https://apps.apple.com/us/app/the-toll-roads/id518393133"
            target="_blank"
            rel="noopener noreferrer"
          >
            design
          </a>{" "}
          and{" "}
          <a
            href="https://apps.apple.com/us/app/paytollo-mobile-tolling-app/id966810136"
            target="_blank"
            rel="noopener noreferrer"
          >
            usability
          </a>
          , as most of them are managed by government agencies. Our team aimed
          to change that, so we focused on making Uproad as straightforward as
          possible.
        </p>
        <p>
          When I joined the team, we faced three UX challenges that had to be
          addressed:
        </p>
        <p>
          <Highlighter text="1. Payment delays" />
        </p>
        <p>
          Tolling agencies cannot charge users right away, so there's always a
          delay with the payment. It usually takes from 1 to 30 days to process
          the toll payment.
        </p>
        <p>
          At that moment, Uproad did not communicate that anywhere in the app,
          so the customer service department received hundreds of requests
          regarding payment delays weekly.
        </p>
        <p>
          <Highlighter text="2. How it works" />
        </p>
        <p>
          Mobile tolling is still a relatively new thing. So, we had users who
          did not know how tolling apps work.{" "}
        </p>
        <p>
          After analysing support cases, we found out that 35% of new users come
          to us with the questions on how the app works.
        </p>
        <p>
          While transponders/stickers (physical box on the windshield) remain
          the most popular way to pay digitally, many users did not know what
          lanes they should take to avoid double charges.
        </p>
        <p>
          <Highlighter text="3. Different states, different rules" />
        </p>
        <p>
          Many drivers download Uproad after they've already passed a toll
          point, but only one tolling agency allows that. So we need to somehow
          communicate that only drivers from California can pay previously
          unpaid tolls.
        </p>
      </AnimatedDiv>

      <AnimatedDiv>
        <h3>Process</h3>
        <p>
          We selected 4 most common user problems that could be solved during
          onboarding by introducing the wizard of 4 screens. Also, a key role in
          the visual design was put on UX writing. The most important thing was
          to explain to the users the specifics of the app in a clear and simple
          way.
        </p>
        <Button
          className="goToCaseButton"
          variant="complex"
          text="STORY OF [NONEXISTENT] SKIP BUTTON"
          onClick={() => goToPage("/case3.1.")} // TODO: change url
          icon={<RightArrow />}
        />
      </AnimatedDiv>

      <AnimatedDiv>
        <h3>Result</h3>
        <p>
          To resolve this, we made two major changes in the user experience:
        </p>
        <p>
          1. Introduced new onboarding experience with the educational
          walkthrough
        </p>
        <p>2. Redesigned transaction details screens</p>
        <p>
          This way, new users are informed on how the app works during their
          account setup. Informational blocks in transaction details serve as an
          additional reminder for everyone who's scared of delayed payments.
        </p>
        <p>
          New onboarding walkthrough sets proper expectations for a user. We
          also had to make a different screen for California users as only they
          can pay their past tolls.
        </p>
      </AnimatedDiv>

      <AnimatedDiv>
        <Carousel images={[Carousel1, Carousel2, Carousel3, Carousel4]} />
      </AnimatedDiv>
    </ContentPage>
  );
}

export default ProperOnboarding;
